import { Component, Input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { FleetTipModalComponent } from '../fleet-tip-modal/fleet-tip-modal.component';

@Component({
  selector: 'app-fleet-card-grok',
  templateUrl: './fleet-card-grok.component.html',
  styleUrls: ['./fleet-card-grok.component.scss'],
})
export class FleetCardGrokComponent {
  @Input() data: any;
  @Input() tokens: any;
  @Input() node: any;
  constructor(private dialog: MatDialog) {}

  goTo() {
    if (this.data.status !== 1) {
      return;
    }
    if (!this.tokens.token || !this.data.carID) {
      this.dialog.open(FleetTipModalComponent, {
        panelClass: 'fleet-tip-dialog',
        data: this.data.car,
      });
      return;
    }

    const url = `https://grok-share.universalbus.cn:8081/auth/loginToken?userToken=${this.tokens.token}&carid=${this.data.carID}`;
    window.open(url, '_blank');
  }
}
